var ClientDealsUpdate, GrouponGsmDeals, clientSideDealGridTemplate;

require('../../optimize_config/frontend/optimize_config');

require('Hogan');

GrouponGsmDeals = require('./deals');

clientSideDealGridTemplate = require('../client_side_deal_grid.html.mustache');

module.exports = ClientDealsUpdate = (function() {
  function ClientDealsUpdate(config) {
    this.hostname = config.hostname;
    this.apiPath = this.pathFromHref();
    this.response = null;
    this.template = clientSideDealGridTemplate;
  }

  ClientDealsUpdate.prototype.pathFromHref = function() {
    var path, pathAndQuery;
    pathAndQuery = window.location.href.toString().split('?');
    if (!(path = $('.deal-space').data('url'))) {
      path = pathAndQuery[0].split(window.location.host)[1] + ".json";
    }
    if (pathAndQuery[1]) {
      path += "?" + pathAndQuery[1];
    }
    return path;
  };

  ClientDealsUpdate.prototype.apiUrl = function() {
    var ref;
    if (((ref = this.hostname) != null ? ref.length : void 0) > 0) {
      return '//' + this.hostname + this.apiPath;
    } else {
      return this.apiPath;
    }
  };

  ClientDealsUpdate.prototype.deals = function(responseCb, errorCb, completeCb) {
    var url;
    if (this.response != null) {
      if (this.response.success_data != null) {
        responseCb(this.response.success_data);
      } else {
        errorCb(this.response.jqxhr, this.response.textStatus, this.response.errorThrown);
      }
      completeCb(this.response.jqxhr, this.response.textStatus);
      return;
    }
    url = this.apiUrl();
    return $.ajax({
      url: url,
      success: (function(_this) {
        return function(data) {
          _this.response || (_this.response = {});
          _this.response.success_data = data;
          return responseCb(data);
        };
      })(this),
      error: (function(_this) {
        return function(jqxhr, textStatus, errorThrown) {
          _this.response || (_this.response = {});
          _this.response.jqxhr = jqxhr;
          _this.response.textStatus = textStatus;
          _this.response.errorThrown = errorThrown;
          return errorCb(jqxhr, textStatus, errorThrown);
        };
      })(this),
      complete: completeCb,
      timeout: 20000,
      dataType: 'jsonp'
    });
  };

  ClientDealsUpdate.prototype.load_deals = function(waitingDiv, targetDiv, cb) {
    var clientTemplate, completeCb, errorCb, hadServerDeals, hasLhNavbar, oldDealsMarkup, responseCb;
    clientTemplate = this.template;
    oldDealsMarkup = $(targetDiv).html();
    $(targetDiv).html($(waitingDiv).html());
    hasLhNavbar = !!$('#refinement-bar').length;
    hadServerDeals = true;
    responseCb = function(data) {
      var deals, new_html;
      deals = new GrouponGsmDeals(data, {}, I18n, {
        hasLeftHandNav: hasLhNavbar
      });
      new_html = clientTemplate.render(I18n.mixin(deals.viewObjects(), I18n));
      if (new_html.length > 0) {
        new_html = $(new_html).filter('*');
        $(targetDiv).html(new_html.html());
        return GIG.Utils.truncateElements($(targetDiv));
      } else if (hadServerDeals) {
        return $(targetDiv).html(oldDealsMarkup);
      } else {
        return $(targetDiv).html('');
      }
    };
    errorCb = function(jqxhr, textStatus, errorThrown) {
      if (hadServerDeals) {
        return $(targetDiv).html(oldDealsMarkup);
      } else {
        return $(targetDiv).html('');
      }
    };
    completeCb = function(jqxhr, textStatus) {
      if (cb != null) {
        return cb();
      }
    };
    return this.deals(responseCb, errorCb, completeCb);
  };

  return ClientDealsUpdate;

})();

//# sourceMappingURL=data:application/json;base64,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
